import React, {useState} from "react";
import style from "./SideBar.module.css";
import Dice1 from "../../image/tmp-png/dice-1.png";
import Dice from "../../image/Dice.jpeg";
import Dice2 from "../../image/tmp-png/dice-2.png";
import Dice3 from "../../image/tmp-png/dice-3.png";
import Dice4 from "../../image/tmp-png/dice-4.png";
import Dice5 from "../../image/tmp-png/dice-5.png";
import Dice6 from "../../image/tmp-png/dice-6.png";
import HandMove from "../../image/tmp-png/hand_move.png"
import Snake from "../../image/snake.png";
import Arrow from "../../image/arrow.png";
import Finish from "../../image/tmp-png/finish.png";
import SixRule_1 from "../../image/tmp-png/3x6plus1.png";
import SixRule_2 from "../../image/tmp-png/3x6plus2.png";
import SixRule_3 from "../../image/tmp-png/3x6plus3.png";
import SixRule_4 from "../../image/tmp-png/3x6plus4.png";
import SixRule_5 from "../../image/tmp-png/3x6plus5.png";
import SixRule_6 from "../../image/tmp-png/3x6plus6.png";
import SixRule_Stop from "../../image/tmp-png/3x6-stop.png";
import Stop from "../../image/tmp-png/stop.png";
import OneStop from "../../image/tmp-png/1-stop.png";
import TwoStop from "../../image/tmp-png/2-stop.png";
import ThreeStop from "../../image/tmp-png/3-stop.png";
import FourStop from "../../image/tmp-png/4-stop.png";
import FiveStop from "../../image/tmp-png/5-stop.png";
import SixStop from "../../image/tmp-png/6-stop.png";
import NoComment from "../../image/commentinactive.png";
import CommentActive from "../../image/commentActive.png";
import HistoryComment from "./HistoryComment";
import * as GroupGameService from "../../api/GroupGameService"
import CardTextModal from "../CardTextModal";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import HistoryDeleteLastMove from "./HistoryDeleteLastMove";
import HistoryMetaphoricCardsModal from "./HistoryMetaphoricCardsModal";
import {useTranslation} from "react-i18next";

function HistoryRow(props) {
    const { t, i18n } = useTranslation('translation', { keyPrefix: 'historyRow' });
    const [commentModalOpened, setCommentModalOpened] = useState(false)
    const [deleteLastStepModalOpened, setDeleteLastStepModalOpened] = useState(false)
    const [cardModalOpened, setCardModalOpened] = useState(false)
    const [errorOnDelete, setErrorOnDelete] = useState("")

    const errorOnDeleteText = t('tooManyStepsRemoved')

    function openDeleteLastMoveDialog() {
        setDeleteLastStepModalOpened(true)
    }

    function closeDeleteLastMoveDialog() {
        setDeleteLastStepModalOpened(false)
    }


    function deleteLastMove() {
        GroupGameService.deleteLastMove(props.gameId, props.playerId, () => {
            closeDeleteLastMoveDialog()
        }, () => setErrorOnDelete(errorOnDeleteText))

    }

    function resolveCellName(cellNumber) {
        return props.cards[cellNumber - 1]?.title
    }

    function resolvePositions(fromPosition, toPosition) {
        if (props.step.type === "metaphoric_card") {
            return t('metaphoricCard')
        }
        if (fromPosition === 0 && toPosition === 0) {
            return t('requestPrep')
        } else if (toPosition === 0) {
            return t('gameStarts')
        } else {
            return toPosition + " " + resolveCellName(toPosition)
        }
    }

    function openModal() {
        setCommentModalOpened(true)
    }

    function closeModal() {
        setCommentModalOpened(false)
    }


    function SetStyle(number, moveType) {
        if (moveType === "hand_move") {
            this.image = HandMove
        } else if (moveType === "snake") {
            this.image = Snake
        } else if (moveType === "arrow") {
            this.image = Arrow
        } else if (moveType === "no_move_enter" || moveType === "no_move_over") {
            switch (number) {
                case 1:
                    this.image = OneStop;
                    break;
                case 2:
                    this.image = TwoStop;
                    break;
                case 3:
                    this.image = ThreeStop;
                    break;
                case 4:
                    this.image = FourStop;
                    break;
                case 5:
                    this.image = FiveStop;
                    break;
                case 6:
                    this.image = SixStop;
                    break;
                default:
                    this.image = Stop;
                    break;
            }
        } else if (moveType === "no_move_68_check_3x6_rule") {
            this.image = SixRule_Stop
        } else if (moveType === "on_finish_position") {
            this.image = Finish
        } else if (moveType === "3x6_rule") {
            switch (number) {
                case 1:
                    this.image = SixRule_1;
                    break;
                case 2:
                    this.image = SixRule_2;
                    break;
                case 3:
                    this.image = SixRule_3;
                    break;
                case 4:
                    this.image = SixRule_4;
                    break;
                case 5:
                    this.image = SixRule_5;
                    break;
                case 6:
                    this.image = SixRule_6;
                    break;
                default:
                    this.image = Dice;
            }
        } else if (moveType === "accumulated") {
            const lastDice = number % 6
            switch (lastDice) {
                case 1:
                    this.image = Dice1;
                    break;
                case 2:
                    this.image = Dice2;
                    break;
                case 3:
                    this.image = Dice3;
                    break;
                case 4:
                    this.image = Dice4;
                    break;
                case 5:
                    this.image = Dice5;
                    break;
                default:
                    this.image = Dice;
            }
        } else if (moveType === "regular") {
            switch (number) {
                case 1:
                    this.image = Dice1;
                    break;
                case 2:
                    this.image = Dice2;
                    break;
                case 3:
                    this.image = Dice3;
                    break;
                case 4:
                    this.image = Dice4;
                    break;
                case 5:
                    this.image = Dice5;
                    break;
                case 6:
                    this.image = Dice6;
                    break;
                default:
                    this.image = Dice;
            }
        } else if (props.step.type === "metaphoric_card") {
            this.image = props.step.image_url
        }

        return Object.assign(
            {
                backgroundImage: "url(" + this.image + ")",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                height: moveType === "accumulated" ? "30px" : "50px",
                width: moveType === "accumulated" ? "30px" : "50px",
                margin: "auto",
                justifyContent: "center",
                backgroundPosition: "center"
            }
        )
    }

    function SetCommentIconStyle() {
        if (props.step.type === "metaphoric_card") {
            return Object.assign(
                {
                    pointerEvents: "none"
                })
        } else if (!props.step.comments || props.step.comments === "" ) {
            this.commentImg = NoComment
        } else {
            this.commentImg = CommentActive
        }
        return Object.assign(
            {
                backgroundImage: "url(" + this.commentImg + ")",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "left",
                height: "20px",
                width: "100%",
                marginLeft: "10px",
                alignSelf: "end",
                cursor: "pointer"

            }
        )
    }

    function renderTooltip(text) {
        return (<Tooltip id="button-tooltip">
            {text}
        </Tooltip>)
    }


    function getHistoryRowStyle() {
        if (props.step.player_move_type === "accumulated") {
            return style.historyRowAccumulated
        } else if (props.step.player_move_type === "no_move_over" && props.step.dice_number > 6) {
            return style.historyRowAccumulatedStop
        }
        else {
            return style.historyRow
        }
    }

    function getDiceImgForNum(num) {
        switch (num) {
            case 1: return Dice1;
            case 2: return Dice2;
            case 3: return Dice3;
            case 4: return Dice4;
            case 5: return Dice5;
            case 6: return Dice6;
            default: return Dice;
        }
    }

    return (
        <>
            <div className={style.historyRowContainer}>
                <div className={getHistoryRowStyle()}>
                    <OverlayTrigger
                        placement="bottom"
                        delay={{show: 400, hide: 50}}
                        overlay={renderTooltip(t('privateComment'))}
                    >
                        <div style={new SetCommentIconStyle()} onClick={openModal}></div>
                    </OverlayTrigger>
                    {(props.step.player_move_type === "accumulated" || (props.step.player_move_type === "no_move_over" && props.step.dice_number > 6)) && <>
                        <div><b>{Math.floor(props.step.dice_number / 6) + "X"}</b> <div className={style.pending6} style={{backgroundImage: "url(" + Dice6 + ")", marginLeft: 0}}/></div>
                        <b style={{display: "flex", alignItems: "center", justifyContent: "center"}}> + </b>
                    </>
                    }
                    {props.step.player_move_type === "no_move_over" && props.step.dice_number > 6 && <div className={style.accumulatedStopLastDice} style={{backgroundImage: "url("+ getDiceImgForNum(props.step.dice_number % 6) +")"}}/>}
                    <div style={new SetStyle(props.step.dice_number, props.step.player_move_type)}></div>
                    <div className={style.historyRowCardTitle}
                         dangerouslySetInnerHTML={{__html: resolvePositions(props.step.from_position, props.step.to_position)}}
                         onClick={() => setCardModalOpened(true)}/>
                    {(props.isLastMove && !props.step.is_automatic && props.is_mentor && props.step.type !== "metaphoric_card") &&
                        <div className={style.deleteComment} onClick={openDeleteLastMoveDialog}></div>}
                </div>
            </div>
            {commentModalOpened &&
                <HistoryComment onClose={closeModal}
                                gameId={props.gameId}
                                stepId={props.step.game_step_id}
                                updateGameState={props.updateGameState}
                                commentText={props.step.comments}
                />
            }
            {deleteLastStepModalOpened &&
                <HistoryDeleteLastMove onClose={closeDeleteLastMoveDialog}
                                onConfirm={deleteLastMove}
                                errorMessage={errorOnDelete}>test</HistoryDeleteLastMove>}
            {(cardModalOpened && props.step.type === "step") &&
                <CardTextModal modalOpened={cardModalOpened} closeModal={() => setCardModalOpened(false)}
                               cellNumber={props.step.to_position} groupGame={true}/>}
            {(cardModalOpened && props.step.type === "metaphoric_card") &&
                <HistoryMetaphoricCardsModal
                    cardLink={props.step.image_url}
                    deckId={props.step.deck}
                    closeModal={() => setCardModalOpened(false)}
                    allowShare={true}
                />
            }
        </>

    )
}

export default HistoryRow